function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.898097 7.84725C0.423499 7.45094 0.418691 6.7232 0.888011 6.32065L7.95144 0.262084C8.60005 -0.294248 9.60249 0.166606 9.60249 1.02112L9.60249 12.9781C9.60249 13.8264 8.61266 14.2894 7.96152 13.7456L0.898097 7.84725Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6025 13C13.6025 13.5523 13.1548 14 12.6025 14C12.0502 14 11.6025 13.5523 11.6025 13L11.6025 1C11.6025 0.447716 12.0502 -4.82823e-08 12.6025 0C13.1548 4.82823e-08 13.6025 0.447715 13.6025 1L13.6025 13Z",
  fill: "white"
});

var SvgIcRewind = function SvgIcRewind(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcRewind, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_rewind.fd916946.svg";
export { ForwardRef as ReactComponent };